module.exports = __webpack_public_path__ + "img/1494416834.528b9597.jpg";